import { Separator } from "@chakra-ui/react-v3";
import { ResourceAnalysis } from "../components/resource-analysis";
import { DocumentsSection } from "../components/side-panel-sections/documents-section";
import { SidePanelLayout } from "../components/side-panel-sections/side-panel-layout";
import { ImmunizationRowData } from "../tables/immunization";

export type ImmunizationSidePanelContentProps = {
  data: ImmunizationRowData;
};

/**
 * Side panel content for immunization resources.
 */
export function ImmunizationSidePanelContent({ data }: ImmunizationSidePanelContentProps) {
  return (
    <SidePanelLayout
      title="Immunization"
      subtitle={data.immunization}
      metadata={`Date: ${data.date}`}
    >
      <ResourceAnalysis />

      <Separator borderColor="border" />

      <DocumentsSection resources={[data.originalData]} resourceType="Immunization" />
    </SidePanelLayout>
  );
}
